import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../../createApiConfig';

export const lmIptvTypeApi = createApi({
  reducerPath: 'lmIptvTypeApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['IPTV types '],
  endpoints: builder => ({
    getIptvType: builder.query({
      query: (params) => ({
        url: `/links/iptv-server-type/`,
        params,
      }),
      providesTags: ['IPTV types '],
    }),

    createIptvType: builder.mutation({
      query: (data) => ({
        url: '/links/iptv-server-type',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['IPTV types '],
    }),

   
  }),
});

export const {
  useGetIptvTypeQuery,
  useCreateIptvTypeMutation,
} = lmIptvTypeApi;
